import {formatThousands} from '../../../shared-utilities/utils-old/formatting';

/**
 * Formats a monetary value with thousands separators and two decimal places.
 */
export const formatQuoteCurrency = (value: number | null | undefined): string => {
  if (value == null || !Number.isFinite(Number(value))) {
    return '';
  }
  return formatThousands(Number(value), 2);
};

/**
 * Formats a debtor account balance for display (Rand prefix).
 */
export const formatDebtorBalance = (balance: number | null | undefined): string => {
  if (balance == null || !Number.isFinite(Number(balance))) {
    return '—';
  }
  return `R ${formatThousands(Number(balance), 2)}`;
};
